import { Component, ViewChild } from "@angular/core";
import { IonicApp, MenuController, Nav, Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { HomeProvider } from "../providers/home/home";
import { MyAlertProvider } from "../providers/my-alert/my-alert";
import { CustomLoadingProvider } from "../providers/custom-loading/custom-loading";
import { NodataProvider } from "../providers/nodata/nodata";
import { Global, global } from "../environments/global";
import { BaseConfigProvider } from "../providers/base-config/base-config";
import { WxProvider } from "../providers/wx/wx";
import { leaveAnimation } from "../environments/animation";
import {
  Validators,
  FormBuilder,
  FormControl,
  FormGroup
} from "@angular/forms";
import { UtilProvider } from "../providers/util/util";
import { HttpProvider } from "../providers/http/http";

// import {HomePage} from "../pages/home/home";

@Component({
  templateUrl: "app.html",
  animations: [leaveAnimation]
})
export class MyApp {
  public global: Global = global;

  isShowInvitedZidou = false;
  rootPage: any;
  is_show_loading = true;
  inviter_open_id;
  token;

  @ViewChild(Nav) nav;
  open_id;

  constructor(
    public platform: Platform,
    public ionicApp: IonicApp,
    public menuCtrl: MenuController,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private homeService: HomeProvider,
    private fb: FormBuilder,
    private wxService: WxProvider,
    public alertService: MyAlertProvider,
    public csLoader: CustomLoadingProvider,
    public nodata: NodataProvider,
    public http:HttpProvider
  ) {

    this.inviter_open_id = this.getParams("inviter_open_id");
    this.verifyCode();

    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();

      this.initVerifyForm();
    });

    // 为了解决后退键能消掉 modal
    this.registerBtn();
  }

  code;

  getCode() {
    let str = window.document.location.search;
    let num = str.indexOf("?");
    str = str.substr(num + 1);
    let arr = str.split("&"); //各个参数放到数组里

    arr.forEach(item => {
      if (item.indexOf("code") != -1) {
        this.code = item.substr(item.indexOf("=") + 1);
      }
    });
  }

  goToHome(token) {
    this.isShowInvitedZidou = false;
    localStorage.setItem(global.token_name, token);
    if (window.location.href.indexOf("#/") == -1) {
      this.rootPage = "NewHomePage";
    }
  }

  verifyCode() {
    this.getCode();
    if (this.code && !window.location.hash) {
      this.csLoader.showLoader();
      this.homeService.verifyCode(this.code).subscribe(
        res => {
          this.csLoader.dismissLoader();
          if (res["content"]["token"]) {
            this.goToHome(res["content"]["token"]);
            this.http.getVipIdentity();
          } else {
            this.open_id = res["content"]["open_id"];
            this.show_add_phone = true;
          }
        },
        err => {
          this.csLoader.dismissLoader();
          if (
            BaseConfigProvider.is_weixin() &&
            !BaseConfigProvider.isPc() &&
            (err.err_name == "ERR_USER_TOKEN_EXPIRED" ||
              err.err_name == "ERR_USER_LOGIN_FAILED" ||
              err.err_name == "ERR_USER_TOKEN")
          ) {
            let a =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              global.app_id +
              "&redirect_uri=" +
              // encodeURIComponent(global.host_url +(!localStorage.getItem(global.token_name)?'':window.location.hash)) +
              encodeURIComponent(global.host_url) +
              "&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect";
            window.location.href = a;
          } else {
            // else if(err.err_name == 'ERR_INVALID_PARAMS'){
            //   if (window.location.href.indexOf('#/') == -1) {
            //     this.rootPage = 'NewHomePage';
            //   }
            //   BaseConfigProvider.open_id = err.open_id;
            // }
            this.rootPage = "ForbiddenPage";
          }
        }
      );
    } else if (localStorage.getItem(global.token_name)) {
      this.rootPage = "NewHomePage";
    } else {
      this.rootPage = "ForbiddenPage";
    }
  }

  /**
   * test*/
  registerBtn() {
    this.platform.registerBackButtonAction(() => {
      console.log("detect back");
      /* native keyboard */
      /*if (this.keyboard.isOpen()) { // Handles the keyboard if open
        this.keyboard.close();
        return;
      }*/

      let activePortal =
        this.ionicApp._loadingPortal.getActive() ||
        this.ionicApp._modalPortal.getActive() ||
        this.ionicApp._toastPortal.getActive() ||
        this.ionicApp._overlayPortal.getActive();

      //activePortal is the active overlay like a modal,toast,etc
      if (activePortal) {
        activePortal.dismiss();
        return;
      } else if (this.menuCtrl.isOpen()) {
        // Close menu if open
        this.menuCtrl.close();
        return;
      }

      let view = this.nav.getActive(); // As none of the above have occurred, its either a page pushed from menu or tab
      let activeVC = this.nav.getActive(); //get the active view

      let page = activeVC.instance; //page is the current view's instance i.e the current component I suppose
      if (this.nav.canGoBack() || (view && view.isOverlay)) {
        this.nav.pop(); //pop if page can go back or if its an overlay over a menu page
      }
      // return;

      /* below is for tab */
      /*if (!(page instanceof TabsPage)) { // Check if the current page is pushed from a menu click

        if (this.nav.canGoBack() || view && view.isOverlay) {
          this.nav.pop(); //pop if page can go back or if its an overlay over a menu page
        }
        else {
          this.showAlert();
        }

        return;
      }

      let tabs = this.app.getActiveNav(); // So it must be a view from a tab. The current tab's nav can be accessed by this.app.getActiveNav();


      if (!tabs.canGoBack()) {

        return this.showExitAlert();
      }


      return tabs.pop();*/
    }, 0);
  }

  /* 验证手机号码 开始*/
  verifyForm: FormGroup;
  code_error;
  code_status = true;
  left_time;
  sms_step = 1;

  initVerifyForm() {
    this.verifyForm = this.fb.group({
      phone: [null, [this.phoneFormat]],
      modifyCode: [
        null,
        [Validators.required, Validators.pattern(/^[0-9a-zA-Z]{6}$/)]
      ],
      invite_code: [null, [Validators.pattern(/^[0-0a-zA-Z]$/)]]
    });
  }

  phoneFormat = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (!this.global.phoneReg.test(control.value)) {
      return { err_phone: true, error: true };
    }
  };

  getFormControl(name) {
    return this.verifyForm.controls[name];
  }

  is_err_phone;

  getModifyMessage() {
    // if(this.global.phoneReg.test(this.verifyForm)){
    if (this.getFormControl("phone").valid) {
      this.sms_step = 2;
      this.left_time = 60;
      let counter = setInterval(_ => {
        if (this.left_time > 0) {
          this.left_time--;
        } else {
          //noinspection TypeScriptUnresolvedFunction
          clearInterval(counter);
          this.sms_step = 1;
        }
      }, 1000);

      this.homeService
        .sendSms(this.getFormControl("phone").value)
        .subscribe(res => {
        });
    } else {
      this.getFormControl("phone").markAsDirty();
    }
  }

  show_add_phone;

  verifyPhone() {
    if (this.verifyForm.valid) {
      this.code_status = true;
      console.log("inviter_open_id", this.inviter_open_id);
      this.homeService
        .verifyPhone(
          this.getFormControl("phone").value,
          this.getFormControl("modifyCode").value,
          this.open_id,
          this.inviter_open_id
        )
        .subscribe(
          res => {
            this.code_status = true;
            this.show_add_phone = false;
            this.token = res["content"]["token"];
            if (this.inviter_open_id) {
              this.show_add_phone = false;
              this.isShowInvitedZidou = true;
            }
            else {
              this.goToHome(this.token);
            }
          },
          err => {
            this.code_status = false;
            if (err.err_name == "ERR_SMS_CODE_EXPIRED") {
              this.code_error = "验证码过期，请重新获取！";
            } else if (err.err_name == "ERR_INVALID_SMS_CODE") {
              this.code_error = "验证码错误，请重新输入！";
            }
          }
        );
    } else {
      this.getFormControl("phone").markAsDirty();
      this.getFormControl("modifyCode").markAsDirty();
    }
  }

  getParams(name) {
    let str = window.document.location.search;
    let num = str.indexOf("?");
    str = str.substr(num + 1);
    let arr = str.split("&"); //各个参数放到数组里

    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf(name) != -1) {
        return arr[i].substr(arr[i].indexOf("=") + 1);
      }
    }
  }


  /* 验证手机号码 结束 */
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts